export const PAINTING_SET_MEDIUM = 'PAINTING_SET_MEDIUM';
export const paintingSetMedium = (medium) => ({ type: PAINTING_SET_MEDIUM, payload: medium });
